// Chained-exclusion search packing for Formers pulls (CHAIN-FETCH-1b).

function dedupCi(titles) {
  const seen = new Set();
  const out = [];
  for (const t of titles) {
    const tl = t.toLowerCase();
    if (!seen.has(tl)) { seen.add(tl); out.push(t); }
  }
  return out;
}

// Round count up to a multiple of 25, cap at 2500. 0 → 0.
export function roundMaxItems(count) {
  if (!count) return 0;
  return Math.min(2500, Math.ceil(count / 25) * 25);
}

// groups: [{index, titles: string[], count: number, enabled: bool}]
// Returns [{search, groups: number[], titles: string[], exclude: string[], overLimit: bool}]
export function buildChain(groups) {
  const eligible = groups.filter(g => g.enabled && g.count > 0);
  const overLimitGroups = eligible.filter(g => g.count > 2500);
  const normalGroups = eligible.filter(g => g.count <= 2500);

  // Sort normal groups by title count, largest first (stable for equal lengths).
  const sorted = [...normalGroups].sort((a, b) => b.titles.length - a.titles.length);

  // First-fit pack: each search ≤ 50 titles AND member-count sum ≤ 2500.
  const normalSearches = [];
  for (const g of sorted) {
    let packed = false;
    for (const s of normalSearches) {
      const combined = dedupCi([...s.titles, ...g.titles]);
      if (combined.length <= 50 && (s._countSum + g.count) <= 2500) {
        s.groups.push(g.index);
        s.titles = combined;
        s._countSum += g.count;
        packed = true;
        break;
      }
    }
    if (!packed) {
      normalSearches.push({
        groups: [g.index],
        titles: dedupCi(g.titles.slice()),
        _countSum: g.count,
      });
    }
  }

  // All normal titles (first 50) for over-limit exclusion.
  const allNormalTitles = dedupCi(normalSearches.flatMap(s => s.titles)).slice(0, 50);

  const result = [];
  let k = 1;

  // Normal searches: search k excludes titles from searches 1..k-1, first 50.
  for (const s of normalSearches) {
    const prevTitles = dedupCi(
      normalSearches.slice(0, k - 1).flatMap(ps => ps.titles)
    ).slice(0, 50);
    result.push({ search: k, groups: s.groups, titles: s.titles, exclude: prevTitles, overLimit: false });
    k++;
  }

  // Over-limit searches: placed after all normal searches; each excludes allNormalTitles.
  // They are never themselves used as an exclusion source for other searches.
  for (const g of overLimitGroups) {
    result.push({
      search: k,
      groups: [g.index],
      titles: dedupCi(g.titles.slice()),
      exclude: allNormalTitles,
      overLimit: true,
    });
    k++;
  }

  return result;
}
